import { render } from "./PdfViewer.vue?vue&type=template&id=2616e650"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"
script.render = render

export default script